import type { Option } from "src/pages/UserDashboard/WorkPackets/Cases/case-types.ts";

export const submissionPathOptions: Option[] = [
  { title: "Template", value: "Template" },
  { title: "Escalations", value: "Escalations" },
  { title: "VM", value: "VM" },
];
